export const SET_THEME = "SET_THEME";

export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const UPDATE_CURRENT_USER = "UPDATE_CURRENT_USER";

export const SET_CHANGES = "SET_CHANGES";
export const RESET_CHANGES = "RESET_CHANGES";
